import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

const state = {
  queue: [],
  currentActionMessage: '',
  isWorking: false
}

const store = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default store



// WEBPACK FOOTER //
// ./src/store/queue/index.js